module.exports = __webpack_public_path__ + "static/media/reviewImg.53849b09.png";